<template>
  <div>
    <a-drawer
        v-model:visible="visibleDrawer"
        :bodyStyle="{ padding: 0 }"
        :closable="false"
        class="drawer"
        placement="right"
        style="color: #000000"
        width="500"
    >
      <div class="header">
        <div v-if="detailsData.type == 1" class="title f-w-b f-16">
          保洁任务
        </div>
        <div v-else-if="detailsData.type == 2" class="title f-w-b f-16">
          维护任务
        </div>
        <div v-else-if="detailsData.type == 3" class="title f-w-b f-16">
          接待任务
        </div>
        <div v-else-if="detailsData.type == 4" class="title f-w-b f-16">
          客房服务
        </div>
        <div v-else-if="detailsData.type == 5" class="title f-w-b f-16">
          其他
        </div>
        <div
            v-if="detailsData.status == 1"
            class="bar"
            style="background-color: #009999"
        >
          待分配
        </div>
        <div
            v-else-if="detailsData.status == 2"
            class="bar"
            style="background-color: #0094ff"
        >
          待执行
        </div>
        <div
            v-else-if="detailsData.status == 3"
            class="bar"
            style="background-color: #ff9900"
        >
          进行中
        </div>
        <div
            v-else-if="detailsData.status == 4"
            class="bar"
            style="background-color: #333333"
        >
          已完成
        </div>
        <div v-else class="bar" style="background-color: #7f7f7f">已取消</div>
      </div>
      <div v-if="tasklist.length > 1" class="task">
        <div
            v-for="(item, index) in tasklist"
            id="tasks-list"
            :key="index"
            :class="{ selTask: taskId == item.id }"
            class="tasks-list"
            @click="selTask(item)"
        >
          <div class="tasks-lef">
            <!-- <u-icon name="checkbox-mark" class="f-vi"></u-icon> -->
            <span style="max-width: 40vw">{{
                item.name ? item.name : "未分配"
              }}</span>
            <span class="m-l-10">{{ item.time }}</span>
            <div v-if="item.type == 1" class="m-l-10 bar f-24">保洁</div>
            <div v-else-if="item.type == 2" class="m-l-10 bar f-24">维护</div>
            <div v-else-if="item.type == 3" class="m-l-10 bar f-24">接待</div>
            <div v-else-if="item.type == 4" class="m-l-10 bar f-24">
              客房服务
            </div>
            <div v-else class="m-l-10 bar f-24">其他</div>
          </div>
          <div class="tasks-rig">
            <!-- <div class="status f-c-w f-24">{{item.status_text}}</div> -->
            <div v-if="item.status == 1" class="status f-c-w f-24">待分配</div>
            <div v-else-if="item.status == 2" class="status f-c-w f-24">
              待执行
            </div>
            <div v-else-if="item.status == 3" class="status f-c-w f-24">
              进行中
            </div>
            <div v-else-if="item.status == 4" class="status f-c-w f-24">
              已完成
            </div>
            <div v-else class="status f-c-w f-24">已取消</div>
          </div>
        </div>
      </div>
      <div class="content">
        <!-- 基础信息 -->
        <div class="title f-w-b">基础信息</div>
        <div class="info">
          <div class="lef f-c-999">被分配人：</div>
          <div class="rig">
            {{ detailsData.mname ? detailsData.mname : "-" }}
          </div>
        </div>
        <div class="info">
          <div class="lef f-c-999">时间：</div>
          <div class="rig">{{ detailsData.date }} {{ detailsData.time }}</div>
        </div>
        <div class="info">
          <div class="lef f-c-999">房间：</div>
          <div class="rig">
            {{ detailsData.hname ? detailsData.hname : "-" }}
          </div>
        </div>
        <div class="info">
          <div class="lef f-c-999">费用：</div>
          <div class="rig">
            <span style="margin-right: 10px">¥{{ detailsData.amount }}</span>
            <template v-if="detailsData.type == 1">
              <span v-if="detailsData.clean_level == 1">简单</span>
              <span v-else-if="detailsData.clean_level == 2">标准</span>
              <span v-else-if="detailsData.clean_level == 3">高级</span>
            </template>
          </div>
        </div>
        <div class="info">
          <div class="lef f-c-999">任务描述：</div>
          <div class="rig">
            {{ detailsData.remark ? detailsData.remark : "-" }}
          </div>
        </div>
        <!-- 附件 -->
        <div v-if="detailsData.rela.length" class="title f-w-b">附件</div>
        <div class="info">
          <a-image
              v-for="(item, index) in detailsData.rela"
              :key="index"
              :src="imgCut(item.url, 'xl')"
              alt="房源图片"
              fit="fill"
              style="
              width: 80px;
              height: 50px;
              object-fit: cover;
              margin: 0 10px 10px 0;
            "
          />
        </div>

        <!-- 日志 -->
        <div
            v-for="(item, index) in detailsData.log"
            :key="index"
            class="f-12"
            style="margin-bottom: 6px"
        >
          <div>{{ item.remark }}</div>
          <div class="f-c-999">{{ item.create_time }}</div>
        </div>
        <div style="height: 60px"></div>

        <!-- 操作 -->
        <div class="operate">
          <div class="lef">
            <a-button
                class="btn-primary"
                style="margin-right: 5px"
                @click="handleAdd"
            >创建任务
            </a-button
            >
            <a-button
                v-if="detailsData.status == 1 || detailsData.status == 2"
                class="btn-primary"
                @click="handleEdit"
            >修改任务
            </a-button
            >
          </div>
          <div class="rig">
            <a-button danger type="link" @click="handleDelTask"
            >删除任务
            </a-button
            >
            <a-button
                v-if="
                detailsData.status == 1 ||
                detailsData.status == 2 ||
                detailsData.status == 3
              "
                class="btn-info"
                @click="handleCancelTask"
            >取消任务
            </a-button
            >
          </div>
        </div>
      </div>
    </a-drawer>

    <!-- 添加修改任务 -->
    <AddTasks
        v-model:visible="visibleAdd"
        :form="addForm"
        :title="modalTitle"
        @confirm="taskEditBack"
    />
  </div>
</template>

<script>
import useUtils from "@/hooks/useUtils.js"; //工具库
import {taskCancel, taskDel, taskDetails} from "@/api/api";
import {createVNode, defineComponent, reactive, toRefs, watch} from "vue";
import {message, Modal} from "ant-design-vue";
import {ExclamationCircleOutlined} from "@ant-design/icons-vue";
import AddTasks from "../../../../components/pms/landlord/tasks/Add.vue";

export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    taskId: {
      type: Number,
      required: true,
    },
  },
  components: {
    AddTasks,
  },
  emits: ["update:visible", "refresh"],
  setup(props, {emit}) {
    let {imgCut} = useUtils();
    // 详情
    const details = reactive({
      visibleDrawer: false,
      visibleAdd: false,
      taskId: "",
      modalTitle: "修改任务",
      addForm: {},
      tasklist: [],

      detailsData: {
        rela: [],
      },
      //   选择任务
      selTask(item) {
        details.taskId = item.id;
        details.getTaskDetail();
      },
      //   修改任务回调
      taskEditBack() {
        details.getTaskDetail();
        emit("refresh");
      },
      //  获取详情
      getTaskDetail() {
        details.visibleDrawer = true;
        taskDetails({
          task_id: details.taskId,
        }).then((res) => {
          details.detailsData = res.data.details;
          details.tasklist = res.data.list;
        });
      },
      //   创建任务
      handleAdd() {
        details.modalTitle = "创建任务";
        details.visibleAdd = true;
        details.addForm = null;
      },
      //   修改任务
      handleEdit() {
        details.modalTitle = "修改任务";
        let obj = JSON.parse(JSON.stringify(details.detailsData));
        obj.hid = obj.hid ? obj.hid : [];
        obj.mid = obj.mid ? obj.mid : [];
        obj.url_arr = obj.rela.length ? obj.rela : [];
        details.addForm = {};
        Object.assign(details.addForm, obj);
        details.visibleAdd = true;
      },
      //  删除任务
      handleDelTask() {
        Modal.confirm({
          title: "确定删除此任务？",
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            taskDel({task_id: details.detailsData.id}).then((res) => {
              message.success(res.msg);
              details.visibleDrawer = false;
              emit("refresh");
            });
          },
        });
      },
      //  取消任务
      handleCancelTask() {
        Modal.confirm({
          title: "确定取消此任务？",
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            taskCancel({task_id: details.detailsData.id}).then((res) => {
              message.success(res.msg);
              details.getTaskDetail();
              emit("refresh");
            });
          },
        });
      },
    });

    watch(
        () => props.visible,
        (newValue) => {
          details.visibleDrawer = newValue;
          if (newValue) {
            details.taskId = props.taskId;
            details.getTaskDetail();
          }
        }
    );

    watch(
        () => details.visibleDrawer,
        (value) => {
          emit("update:visible", value);
        }
    );

    return {
      ...toRefs(details),
      imgCut,
    };
  },
});
</script>

<style lang="scss" scoped>
.task {
  background-color: #ffffff;
  margin-bottom: 5px;
  max-height: 200px;
  overflow-y: auto;

  .m-l-10 {
    margin-left: 5px;
  }

  .selTask {
    background-color: #0094ff11;
    // color: #FFFFFF !important;
  }

  .tasks-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    border-bottom: 1px solid #f7f7f7;
    padding: 0 20px;
    cursor: pointer;

    &:hover {
      background-color: #f2f2f2;
    }

    .tasks-lef {
      text-align: left;
      display: flex;
      align-items: center;
    }

    .tasks-rig {
    }
  }

  .bar {
    // border: 2rpx solid #999999;
    border-radius: 5px;
    padding: 1px 5px;
    background-color: #f2f2f2;
    color: #000000;
  }

  .status {
    border-radius: 15px;
    padding: 2px 5px;
    font-size: 12px;
  }
}

.drawer {
  // position: absolute;
  .header {
    height: 60px;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;

    .bar {
      border-radius: 10px;
      padding: 2px 10px;
      height: 20px;
      width: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 12px;
    }

    .title {
    }

    .status {
    }
  }

  .content {
    padding: 20px;

    .title {
      padding: 10px 0;
    }

    .info {
      display: flex;
      padding: 7px 0;

      .lef {
        width: 200px;
      }

      .rig {
        width: 300px;
      }
    }
  }

  .operate {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0;
    width: 450px;
    height: 60px;
    border-top: 1px solid #f2f2f2;
    background-color: #fff;

    .lef {
    }

    .rig {
    }
  }
}
</style>
